// extracted by mini-css-extract-plugin
module.exports = {"backLink":"_bca4f34","backLinkText":"_53968569"};